<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="debtPayData"
      dateField="Date"
      numberField="PayNumber"
    />

    <template v-if="debtPayData.VendorID">
      <kst-output field="VendorID" :data="debtPayData" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="VendorAlias" :data="debtPayData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="VendorName" :data="debtPayData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="VendorID" :data="debtPayData" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="VendorName" :data="debtPayData" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="PaymentTypeName" :data="debtPayData" :catalog="Catalog"/>
    <kst-output field="PaymentValue" :data="debtPayData" :catalog="Catalog"/>
    <kst-output field="Comment" :data="debtPayData" :catalog="Catalog"/>
    <kst-output field="StatusID" :data="debtPayData" :catalog="Catalog"/>
    <kst-created :data="debtPayData"/>
    <kst-output field="WarehouseID" :data="debtPayData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../DbpyCatalog.js";

export default {
  props: {
    debtPayData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>